<template>
    <div :class="['insert-rec','insert-shop-card','shop-house',expiredClass]">
        <a href="javascript:void(0);" class="insert-box" data-spm-data="h" :data-spm-content="dataSpmContent">
            <div class="img-box img-do">
                <img class="insert-article__img" :src="image" alt="配图">
            </div>
            <div class="insert-content">
                <h5 class="insert-rec__title">{{title}}</h5>
                <div class="footer">
                    <p v-if="p1">{{p1}}</p>
                    <p v-if="p2">{{p2}}</p>
                    <p v-if="p3">{{p3}}</p>
                </div>
            </div>

            <div style="clear: both;"></div>
            <div class="shop-house-opare">
                <div class="input-box name-input-box">
                    <span class="col-title">姓名</span>
                    <input class="col-input" type="text" placeholder="请输入姓名" v-model.trim="nameInput" @click="hideError"/>
                </div>
                <div class="input-box telephone-input-box">
                    <span class="col-title">手机</span>
                    <input class="col-input" type="text"  maxlength="11" placeholder="请输入手机号" v-model.trim="telephoneInput" @click="hideError"/>
                </div>
                <div class="input-box code-input-box">
                    <span class="col-title">验证码</span>
                    <input class="col-input" type="text" placeholder="请输入验证码" maxlength="6" v-model="codeInput" @click="hideError"/>
                    <span class="get-code-btn" @click="getMsgCode"><span class="btn-text">{{codeText}}</span></span>
                </div>
            </div>

            <span class="error-tip" v-if="showErrorTip">{{errorText}}</span>
            <div class="insert-btn enroll-btn enroll-btn-done fixPosition" v-if="isOverdue">报名结束</div>
            <div class="insert-btn enroll-btn show-enroll-btn fixPosition" v-else @click="showEnrollBox">{{enrollText}}</div>
        </a>
        <div style="clear: both"></div>
        <div class="dialog-tip" v-if="showDialogTip">{{dialogTipText}}</div>
        <div class="rec" v-if="cardInfo.accountName && cardInfo.avatar">
            <div class="rec-avator"><img :src="cardInfo.avatar"/></div>
            <div class="rec-text">{{cardInfo.accountName}}推荐</div>
            <div class="rec-expired-tag" v-if="status === 4 || status === 3">已失效</div>
        </div>
    </div>
</template>

<script>
import { setPicSize } from "../../../utils/pic-util.js"
import { jsonp } from '../../../request/jsonp'
import { env } from '@/env'

export default {
	name: "house-enroll",
    props: {
        cardInfo: {
			type: Object,
			default: () => {
				return {};
			},
		},
    },
    data() {
        return {
            opareBox: '',
            enrollBtn: '',
            errorTip: '',
            MsgCodeApiF: false,
            codeTime: 0,
            countDown: 10,
            telephoneInput: '',
            showErrorTip: false,
            errorText: '请输入姓名',
            showDialogTip: false,
            dialogTipText: '',
            codeInterval: '',
            nameInput: '',
            codeInput: '',
            enrollText: '立即报名'
        }
    },
    mounted() {
        this.enrollBtn = document.querySelector('.enroll-btn')
        this.errorTip = document.querySelector('.error-tip')
    },
    computed: {
        fields() {
            return this.cardInfo?.fields || {}
        },
        title() {
            return this.fields?.title?.substring(0,26) || ''
        },
        desc() {
            return this.fields?.desc?.substring(0,26) || ''
        },
        image() {
            return setPicSize(this.fields?.image, 1060, undefined, 'c_zoom')
        },
        dataSpmContent() {
            return '||' + this.cardInfo?.uuid + '|||'
        },
        status() {
            return this.cardInfo?.status || 1
        },
        expiredClass() {
            return this.status === 4 || this.status === 3 ? 'expired' : ''
        },
        p3() {
            return this.fields?.remark
        },
        p2() {
            return this.fields?.deadlineString
        },
        p1() {
            let p1 = this.fields?.assemblyAddress || this.fields?.desc
            if(this.p2) {
                return p1.substring(0,22)
            }
            return p1.substring(0,50)
        },
        applicationDeadline() {
            return this.fields?.applicationDeadline
        },
        isOverdue() {
            if(this.applicationDeadline) {
                return (+this.applicationDeadline < new Date().getTime())
            }
            return false
        },
        codeText() {
            if(this.codeTime === 0) {
                return '获取验证码'
            }else {
                return this.codeTime + '秒后重发'
            }
        },
        clkParam() {
            const pcArticleInfo = window.pcArticleInfo
            return 'accountId:' + pcArticleInfo?.media_id + ';articleId:' + pcArticleInfo?.news_id + ';cardId:' + this.cardInfo?.uuid
        }
    },
    methods: {
        showEnrollBox() {
            var enrollBtn = document.querySelector('.enroll-btn')
            enrollBtn.classList.remove('show-enroll-btn');
            enrollBtn.classList.add('enroll-btn-submit');
            window.sohuSpm?.sendAction({acode:8616,clkParam:this.clkParam})
            this.submitEnroll()
        },
        submitEnroll() {
            if (this.MsgCodeApiF) {
                return false;
            }
            // 校验
            if (this.checkValue()) {
                this.MsgCodeApiF = true;
                var params = {
                    id: this.cardInfo?.uuid,
                    articleId: window.pcArticleInfo?.news_id,
                    name: this.nameInput,
                    phoneNum: this.telephoneInput,
                    captcha: this.codeInput
                }
                const baseUrlMap = {
                    'test':'//test.mp.sohu.com/fe',
                    'pre':'//v2.sohu.com/mpfe',
                    'prod':'//v2.sohu.com/mpfe',
                }
                let baseUrl = baseUrlMap[env]
                jsonp(`${baseUrl}/card/apply`,params).then((res)=>{
                    if (res.code === 2000000) {
                        this.enrollOk();
                        window.sohuSpm?.sendAction({acode:8618,clkParam:this.clkParam})
                    } else {
                        this.showError(res.msg);
                    }
                    this.MsgCodeApiF = false;
                }).catch(()=>{
                    this.showError('异常，报名失败');
                    this.MsgCodeApiF = false;
                })
            }
        },
        // 报名成功
        enrollOk () {
            this.showDialog('报名成功');
            var enrollBtn = document.querySelector('.enroll-btn')
            var opareBox = document.querySelector('.shop-house-opare')
            opareBox.style.display = 'none'
            enrollBtn.classList?.add('enroll-btn-done')
            enrollBtn.classList?.remove('enroll-btn-submit')
            enrollBtn.classList?.remove('fixPosition')
            this.enrollText = '已报名'
        },
        checkValue () {
            var nameReg=/^([\u4e00-\u9fa5]){2,5}$/;
            var codeReg = /^\d{6}$/;
            if (!nameReg.test(this.nameInput)) {
                this.showError('名字输入有误，请重新输入')
                return false
            } else if (!this.checkTelePhone()) {
                return false
            } else if (!codeReg.test(this.codeInput)) {
                this.showError('验证码输入有误，请重新输入')
                return false
            }

            return true
        },
        getMsgCode() {
            if (this.MsgCodeApiF) {
                return false;
            }
            if (this.checkTelePhone() && this.codeTime == 0) {
                this.MsgCodeApiF = true;
                const data = {
                    phoneNum: this.telephoneInput,
                    id: this.cardInfo?.uuid
                }
                const baseUrlMap = {
                    'test':'//test.mp.sohu.com/fe',
                    'pre':'//v2.sohu.com/mpfe',
                    'prod':'//v2.sohu.com/mpfe',
                }
                let baseUrl = baseUrlMap[env]
                jsonp(`${baseUrl}/card/getCaptcha`,data).then((res)=>{
                    if(res && res.code == 2000000) {
                        this.setCodeTime();
                        window.sohuSpm?.sendAction({acode:8617,clkParam:this.clkParam})
                    }else {
                        this.showDialog('验证码获取失败');
                    }
                    this.MsgCodeApiF = false;
                }).catch(()=>{
                    this.MsgCodeApiF = false;
                    this.showDialog('验证码获取失败');
                })
            }
        },
        checkTelePhone () {
            var telReg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
            if (!telReg.test(this.telephoneInput)) {
                this.showError('手机号输入有误，请重新输入')
                return false
            }
            return true
        },
        showError (text) {
            this.showErrorTip = true
            this.errorText = text
        },
        showDialog(text) {
            this.showDialogTip = true
            this.dialogTipText =  text
            setTimeout(()=>{
                this.showDialogTip = false
            },3000)
        },
        setCodeTime () {
            this.codeTime = this.countDown
            this.codeInterval = setInterval( () => {
                this.codeTime = --this.codeTime;
                if (this.codeTime === 0) {
                    clearInterval(this.codeInterval);
                }
            }, 1000)
        },
        hideError () {
            this.showErrorTip = false
            this.errorText = ''
    },
    }
}
</script>

<style lang="less" scoped>

</style>